import React from 'react';

import { AriaRoles } from '../../../constants/AccessibilityConstants';

import './DropdownHr.scss';

class DropdownHr extends React.Component {
  render() {
    return <li className='DropdownHr' role={AriaRoles.PRESENTATION} />;
  }
}

export default DropdownHr;
